import * as reservationInquiryAmount from './actions';
import reducer from './reducer';

export interface InitialReservationInquiryAmount {
  unregisteredAmount: number,
}


export {
  reservationInquiryAmount,
};

export default reducer;
